import { fetchReachout } from '../../services/outcomeItems'
import { resolveTimelineDialog } from '../../services/timelineModals'
import { formatTimelineItemDetail } from '../../services/timelineDetail'
import { activityPillTitle } from '../utils/candidates'
import { useDrawerDialog } from '../../hooks/useDrawerDialog'

export function useActivityDialog(options: { onUpdated?: () => void } = {}) {
  const { openDrawerDialog, closeDrawerDialog } = useDrawerDialog()

  async function openActivityDialog(source: any) {
    let item: any = {
      type: source.type,
      id: source.id,
      data: source.data || {},
      created_at: source.occurred_at ?? source.created_at,
    }

    if (String(source.type).startsWith('reachout_')) {
      try {
        item = await fetchReachout(source.id)
      } catch (e: any) {
        openDrawerDialog({ title: 'Activity', body: e?.message || 'Could not load this reachout.' })
        return
      }
    }

    const accountId = source.account_id || ''
    const onClose = () => closeDrawerDialog()
    const onUpdated = () => { closeDrawerDialog(); options.onUpdated?.() }

    const dialog = resolveTimelineDialog(item, { accountId, onClose, onUpdated })
    if (dialog) {
      openDrawerDialog(dialog)
      return
    }
    const detail = formatTimelineItemDetail(item)
    openDrawerDialog(detail || { title: activityPillTitle(source), body: source.label || '' })
  }

  return { openActivityDialog }
}
